( () => {
  const EXTRA_OFFSET_PX = 100;

  // Elements that should trigger a section scroll
  const SCROLL_SELECTOR = `
    .facetwp-page,
    .facetwp-facet .facetwp-radio,
    .facetwp-facet .facetwp-checkbox,
    .facetwp-facet .facetwp-dropdown,
    .facetwp-facet .facetwp-search
  `;

  const getOffset = () => {
    const adminBar = document.getElementById( 'wpadminbar' );
    const header = document.querySelector( 'header' );
    return ( header?.offsetHeight || 0 ) + ( adminBar?.offsetHeight || 0 ) + EXTRA_OFFSET_PX;
  };

  const doScrollTo = ( section ) => {
    if ( !section ) return;
    const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
    const top = section.getBoundingClientRect().top + scrollY - getOffset();
    window.scrollTo( { top: Math.max( 0, top ), behavior: 'smooth' } );
  };

  const debounce = ( fn, wait = 180 ) => {
    let t;
    return ( ...args ) => {
      clearTimeout( t );
      t = setTimeout( () => fn( ...args ), wait );
    };
  };

  let userInitiated = false;
  let pendingSection = null;

  const requestScroll = ( section ) => {
    userInitiated = true;
    pendingSection = section || pendingSection || document.querySelector( 'section' );
    debouncedScroll();
  };

  const debouncedScroll = debounce( () => {
    if ( !userInitiated ) return;
    const section =
      ( pendingSection && document.body.contains( pendingSection ) && pendingSection ) ||
      document.querySelector( 'section' );
    doScrollTo( section );
    pendingSection = null;
    userInitiated = false;
  }, 180 );

  document.addEventListener( 'click', ( e ) => {
    const trigger = e.target.closest( SCROLL_SELECTOR );
    if ( !trigger ) return;
    const section = trigger.closest( 'section' );
    requestScroll( section );
  } );

  document.addEventListener( 'change', ( e ) => {
    const trigger = e.target.closest( SCROLL_SELECTOR );
    if ( !trigger ) return;
    const section = trigger.closest( 'section' );
    requestScroll( section );
  } );

  document.addEventListener( 'facetwp-loaded', () => {
    if ( !userInitiated ) return;
    if ( !pendingSection || !document.body.contains( pendingSection ) ) {
      const active =
        document.activeElement?.closest?.( '.facetwp-facet' ) ||
        document.querySelector( '.facetwp-facet' );
      pendingSection = active?.closest?.( 'section' ) || document.querySelector( 'section' );
    }
    debouncedScroll();
  } );
} )();
